import React, {Component} from 'react'; 
  
import AOS from "aos";

 
class ServicesContent extends React.Component{

    constructor(props){
        super(props);

        
        this.state = {
            content : [],
            page_content:[],
            loading : 1,
            settings:{}
        }
        

    }

    componentDidMount() {
  this.setState(
    {
      loading: 0,
      content: this.props.service,
    },
   
  );
}

    render()
    { 

        if (this.state.loading === 1) {
            return <div>Loading...</div>;
          }
    return (
        <div>
            
             <section className="section-padded">
        <div className="content aos-init"
        >
           <div  dangerouslySetInnerHTML={{ __html: this.props.service.description}} />  
        </div>
      </section>

      
{this.props.service.techniques && this.props.service.techniques.length > 0 && 
      <section class="section-padded">
        
        <div class="extra-cards">

          {this.props.service.techniques.map((item, index) => (

                <div class="extra-card">
                  {item.icon != "" &&
                      <div class="extra-icon fitted">
                          <img src={item.icon} />
                      </div> 
                 }
                  {item.image !== "" &&
<div class="extra-icon ">
                  <img src={item.image} />
                  </div>
                  }

                      <div class="extra-content-wrapper">
                        <div class="extra-title">
                          {item.title}
                        </div> 
                        <div class="extra-content"><span>{item.description || ""}</span>
                          </div>
                    </div>
                  </div>
          
          ))}
            </div>
            </section>
             
        }
           
  
             
{this.props.service.partners  && this.props.service.partners.length > 0 && 
      <section class="section-padded">
        
        <div class="extra-cards-partners">

          {this.props.service.partners.map((item, index) => (

            <div class="extra-card">
              <div class="extra-icon"><img src={item.logo} /></div>
              <div class="extra-content-wrapper"><div class="extra-title">
            {item.title} 
          </div> <div class="extra-subtitle">
            {item.subtitle} 

          </div> <div class="extra-content"><span><p><div  dangerouslySetInnerHTML={{ __html: this.props.service.description}} />  </p>
          </span> <a target="_blank" href={item.website} class="visit readmore">VISIT PARTNER</a>
          </div></div></div>

               
          
          ))}
            </div>
            </section>
             
        }
           
  
             

           
  
        </div>
       

    );
 
    }
}

export default ServicesContent;